import React from "react";
import { Box } from "@mui/material";

// デモ機能における入力情報の取扱い（プライバシーポリシー該当箇所）へのリンク。
export default function DemoInputInfoLink() {
  return (
    <Box
      component="a"
      href="/privacy_policy#demo-data"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ color: "#5179d6", textDecoration: "underline" }}
    >
      デモ機能における入力情報の取扱い
    </Box>
  );
}
